import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentCommunity: {},
  currentCommunityLeader: {},
  isRefetchMultiCommunityList: false,
  isRefetchUser: false,
  allUsersIds: [],
  isRefetchFromSettingPage: "",
};

export const multiCommunity = createSlice({
  name: "multiCommunity",
  initialState,
  reducers: {
    clearMultiCommunityState: () => initialState,
    setCurrentCommunity: (state, action) => {
      state.currentCommunity = action.payload;
    },
    setCurrentCommunityLeader: (state, action) => {
      state.currentCommunityLeader = action.payload;
    },
    setRefetchMultiCommunityList: (state, action) => {
      state.isRefetchMultiCommunityList = action.payload;
    },
    setRefetchPage: (state, action) => {
      state.isRefetchFromSettingPage = action.payload;
    },
    setRefetchSpecificUser: (state, action) => {
      state.isRefetchUser = action.payload;
    },
    setAllUserIdsForStats: (state, action) => {
      state.allUsersIds = action.payload;
    },
  },
});

export const {
  clearMultiCommunityState,
  setCurrentCommunity,
  setCurrentCommunityLeader,
  setRefetchMultiCommunityList,
  setRefetchPage,
  setRefetchSpecificUser,
  setAllUserIdsForStats,
} = multiCommunity.actions;

export default multiCommunity.reducer;
